import { DatePicker } from "antd";
import { Dayjs } from "dayjs";

import React, { useEffect } from "react";

type CustomFormItemProps = {
  value?: Dayjs;
  onChange?: (value: Dayjs) => void;
  startdate: Dayjs;
};

/**
 * A component that renders a calendar.
 * @param value initialValue passed by parent Form.Item.
 * @param onChange a callback for Form.Item to read its child component's value.
 * @constructor
 */
export const EndDateSelect: React.FC<CustomFormItemProps> = ({
  value,
  onChange,
  startdate,
}) => {
  useEffect(() => {
    //If the startdate changes and is greater than the current enddate value end date will be changed
    if (startdate > value) {
      onChange(startdate);
    }
  }, [startdate]);

  return (
    <DatePicker
      picker={"date"}
      onChange={(date, dateString) => {
        if (date !== null) {
          onChange(date);
        }
      }}
      disabledDate={(current) => {
        // Can not select dates prior to the dates from startdate
        return current < startdate;
      }}
      value={value}
      style={{ width: "100%" }}
      showTime={false}
      format={"DD.MM.YYYY"}
    />
  );
};
